import React, { useCallback, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { theme } from 'styled-tools'
import Textarea from '../../customer-form/textarea'
import settings from '../../settings'
import useTranslation from '../../../../utils/translation'

const StyledTextarea = styled(Textarea)`
  border: 1px solid
    ${(props) =>
      theme('questionBlock.textArea.borderColor')(props) ||
      theme('forms.colors.border')(props)};
  width: 100%;
  height: 140px;
  font-family: ${theme('typography.paragraph.fontFamily')};
  font-size: ${theme('questionBlock.textArea.fontSize')};
  border-radius: ${theme('questionBlock.textArea.borderRadius')};

  textarea& {
    border: 1px solid ${theme('forms.colors.border')};
  }
  textarea&:focus,
  textarea&:active {
    border: 1px solid ${theme('forms.colors.activeBorder')};
  }
  &::placeholder {
    color: ${theme('forms.colors.placeholder')};
  }

  ${(props) => props.theme.media.min.sm`
    width: ${theme(
      'questionBlock.textareaWrapper.textArea.width',
      '370px'
    )(props)};
  `}
  &:focus {
    outline: none;
    border: 1px solid ${theme('forms.colors.activeBorder')};
    box-shadow: ${theme('colors.accentShadow')};
  }
`

const TextAreaSupportingText = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  padding-bottom: 10px;
`

const StyledTextareaWrapper = styled.div`
  ${(props) => props.theme.media.min.sm`
    display: ${theme(
      'questionBlock.textareaWrapper.displayBlock',
      'flex'
    )(props)};
    align-items: flex-end;
  `};
  margin-bottom: 14px;

  & > div {
    margin-bottom: 0;
  }
  ${(props) =>
    props.theme.questionBlock?.textareaWrapper?.flexBasis
      ? css`
          flex-basis: ${theme('questionBlock.textareaWrapper.flexBasis')};
        `
      : ''};
`

export const TextareaQuestion = ({ question, answers, onChange }) => {
  const t = useTranslation('app.prep-form')
  const [text, setText] = useState(answers[0] || '')

  useEffect(() => {
    setText(answers[0])
  }, [answers])

  const onBlur = useCallback(() => {
    if (answers[0] === text) {
      return
    }
    if (text) {
      onChange([text])
    } else {
      onChange([])
    }
  }, [onChange, answers, text])

  return (
    <StyledTextareaWrapper>
      {question.questionSupportingText && settings.brand === 'magnet' && (
        <TextAreaSupportingText>
          {question.questionSupportingText}
        </TextAreaSupportingText>
      )}
      <StyledTextarea
        data-track="info"
        placeholder={question.otherAnswerText || t('placeholder-text')}
        onChange={(e) => setText(e.target.value)}
        onBlur={onBlur}
        value={text}
      />
    </StyledTextareaWrapper>
  )
}
